/**
 * Returns the earliest date in the year, in a format that is sendable to
 * the API's startDate[after] parameters, e.g. "2023-01-01 00:00:00".
 */
export function firstTimeInYear(year: string): string {
  return `${year}-01-01 00:00:00`;
}

/**
 * Returns the latest date of the year, in a format that is sendable to
 * the API's startDate[before] parameters, e.g. "2023-12-31 23:59:59".
 */
export function lastTimeInYear(year: string): string {
  return `${year}-12-31 23:59:59`;
}
